// filepath: /C:/Users/nitis/Desktop/uii/client/src/components/auth/Logout.js
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const RecruiterLogout = () => {
    const navigate = useNavigate();

    useEffect(() => {
        // Remove the token from local storage
        localStorage.removeItem('token');
        // Set the logout notification message
        localStorage.setItem('notification', 'Successfully Logged Out!');
        // Redirect to the login page
        navigate('/recruiter/login');
    }, [navigate]);

    return null;
};

export default RecruiterLogout;